export default __webpack_public_path__ + "static/media/youtube.1ae58151.svg";